module.exports = __webpack_public_path__ + "assets/img/preview_02.c7fdd081.png";